import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpNetworkPointDetails
     * @memberof app
     *
     * @restrict E
     *
     * @description
     * Ain't Nobody Got Time for That
     *
     * @param {Object} networkPoint `NetworkPointDto` from the backend.
     * @param {Number} tsoNumber For example used to get attributes like `tso0Name` or `tso1Name`.
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .directive('pkpNetworkPointDetails', pkpNetworkPointDetails);

    function pkpNetworkPointDetails() {
        return {
            restrict: 'E',
            scope: {
                networkPoint: '=',
                tsoNumber: '@'
            },
            template:
                require('app/_directives/pkp-network-point-details.directive.html')
        };
    }
})();
